import { withAuthUser } from 'next-firebase-auth'
import { Lessons } from 'views/lessons'

export default withAuthUser()(Lessons)
